import React, { useState, useEffect, useRef, useCallback } from "react";
import { FaRegDotCircle, FaRegStopCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import MicRecorder from "mic-recorder-to-mp3";

import { callBuildPermissionsQuery } from "../../../lib/func/ExportFunction";

// 20261015 최대 녹음 시간(초) - 도달 시 자동 종료 후 전송
const MAX_RECORD_SEC = 60;

// 20261015 남은 시간 강조 기준(초) - 이 시간 이하로 남으면 빨간색 표시
const WARN_REMAIN_SEC = 10;

const AudioRecord = ({ onHandleClassTalkFunc, handleSelectedClassTalkFunc }) => {
    const { t } = useTranslation();

    const interval = useRef(null);
    // 20261015 자동 종료 판단용 ref (setInterval 클로저의 오래된 state 참조 및 중복 종료 방지)
    const isRecordingRef = useRef(false);
    const startTimeRef = useRef(0);
    const mp3Recorder = useRef(new MicRecorder({ bitRate: 128 }));

    const [isTryToGetPermission, setIsTryToGetPermission] = useState(false);
    const [isRecording, setRecording] = useState(false);
    const [isBlocked, setBlocked] = useState(true);
    const [curTime, setCurTime] = useState(0);
    const [startTime, setStartTime] = useState(0);

    const getPermissionHandler = useCallback(async () => {
        if (isTryToGetPermission) {
            let constraints = { audio: true };  // use default audio input

            if (navigator.permissions === undefined || navigator.permissions === null) {
                callBuildPermissionsQuery();
            }

            if (navigator.mediaDevices === undefined || navigator.mediaDevices === null) {
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                navigator.getUserMedia({ audio: true },
                    () => {
                        setBlocked(false);
                    },
                    (err) => {
                        console.log("AudioRecord(1) - err => ", err);
                        setBlocked(true);
                        alert(t("오디오_녹음_알림_메시지_1", { ns: "classTalk" }));
                        handleSelectedClassTalkFunc({ selectedFunc: "CLOSE_VOICE_MEMO" });
                    });
            } else {
                let audioStream = null;
                let errMsg = t("오디오_녹음_알림_메시지_2", { ns: "classTalk" });
                let isGranted = false;

                try {
                    const result = await navigator.permissions.query({ name: "microphone" });
                    if (result.state === "granted") { // 매번 권한 요청하는 대신 기존 권한 허용 여부 먼저 체크로 수정 by hjkim 20220208
                        isGranted = true;
                        setBlocked(false);
                    } else {
                        audioStream = await navigator.mediaDevices.getUserMedia(constraints);
                    }
                } catch (err) {
                    console.log("AudioRecord(2) - err => ", err);
                    if (err instanceof DOMException) {
                        console.log(`DOMException name[${err.name}], message: ${err.message}`);
                        if (err.name === "NotAllowedError") {
                            errMsg = t("오디오_녹음_알림_메시지_1", { ns: "classTalk" });
                        } else if (err.name === "NotReadableError") {
                            errMsg = t("오디오_녹음_알림_메시지_3", { ns: "classTalk" });
                        } else if (err.name === "AbortError") {
                            errMsg = t("오디오_녹음_알림_메시지_4", { ns: "classTalk" });
                        } else if (err.name === "NotFoundError" || err.name === "OverconstrainedError") {
                            errMsg = t("오디오_녹음_알림_메시지_5", { ns: "classTalk" });
                        } else if (err.name === "SecurityError") {
                            errMsg = t("오디오_녹음_알림_메시지_6", { ns: "classTalk" });
                        }
                    } else if (err instanceof TypeError) {
                        console.log(`TypeError name[${err.name}], message: ${err.message}`);
                        errMsg = t("오디오_녹음_알림_메시지_6", { ns: "classTalk" });
                    } else {
                        console.log(`Error name[${err.name}], message: ${err.message}`);
                    }
                } finally {
                    if (audioStream !== null || isGranted) {
                        setBlocked(false);
                    } else {
                        setBlocked(true);
                        alert(errMsg);
                        handleSelectedClassTalkFunc({ selectedFunc: "CLOSE_VOICE_MEMO" });
                    }
                }

                /* let audioStream = null;
                let errMsg = t("오디오_녹음_알림_메시지_2", { ns: "classTalk" });

                try {
                    const result = await navigator.permissions.query({ name: "microphone" });
                    if (result.state === "granted") { // 매번 권한 요청하는 대신 기존 권한 허용 여부 먼저 체크로 수정 by hjkim 20220208
                        setBlocked(false);
                    } else {
                        try {
                            audioStream = await navigator.mediaDevices.getUserMedia(constraints);
                        } catch (err) {
                            console.log("AudioRecord(2) - err => ", err);
                            if (err instanceof DOMException) {
                                console.log(`DOMException name[${err.name}], message: ${err.message}`);
                                if (err.name === "NotAllowedError") {
                                    errMsg = t("오디오_녹음_알림_메시지_1", { ns: "classTalk" });
                                } else if (err.name === "NotReadableError") {
                                    errMsg = t("오디오_녹음_알림_메시지_3", { ns: "classTalk" });
                                } else if (err.name === "AbortError") {
                                    errMsg = t("오디오_녹음_알림_메시지_4", { ns: "classTalk" });
                                } else if (err.name === "NotFoundError" || err.name === "OverconstrainedError") {
                                    errMsg = t("오디오_녹음_알림_메시지_5", { ns: "classTalk" });
                                } else if (err.name === "SecurityError") {
                                    errMsg = t("오디오_녹음_알림_메시지_6", { ns: "classTalk" });
                                }
                            } else if (err instanceof TypeError) {
                                console.log(`TypeError name[${err.name}], message: ${err.message}`);
                                errMsg = t("오디오_녹음_알림_메시지_6", { ns: "classTalk" });
                            }
                        } finally {
                            if (audioStream !== null) {
                                setBlocked(false);
                            } else {
                                setBlocked(true);
                                alert(errMsg);
                                handleSelectedClassTalkFunc({ selectedFunc: "CLOSE_VOICE_MEMO" });
                            }
                        }
                    }
                } catch (err) {
                    console.log("AudioRecord(3) - err => ", err);
                    if (err instanceof DOMException) {
                        console.log(`DOMException name[${err.name}], message: ${err.message}`);
                        if (err.name === "NotAllowedError") {
                            errMsg = t("오디오_녹음_알림_메시지_1", { ns: "classTalk" });
                        } else if (err.name === "NotReadableError") {
                            errMsg = t("오디오_녹음_알림_메시지_3", { ns: "classTalk" });
                        } else if (err.name === "AbortError") {
                            errMsg = t("오디오_녹음_알림_메시지_4", { ns: "classTalk" });
                        } else if (err.name === "NotFoundError" || err.name === "OverconstrainedError") {
                            errMsg = t("오디오_녹음_알림_메시지_5", { ns: "classTalk" });
                        } else if (err.name === "SecurityError") {
                            errMsg = t("오디오_녹음_알림_메시지_6", { ns: "classTalk" });
                        }
                    } else if (err instanceof TypeError) {
                        console.log(`TypeError name[${err.name}], message: ${err.message}`);
                        errMsg = t("오디오_녹음_알림_메시지_6", { ns: "classTalk" });
                    }
                    setBlocked(true);
                    alert(errMsg);
                    handleSelectedClassTalkFunc({ selectedFunc: "CLOSE_VOICE_MEMO" });
                } */
            }
        }
    }, [isTryToGetPermission]);

    useEffect(() => {
        return () => {
            isRecordingRef.current = false; // 20261015 언마운트 시 녹음 상태 정리
            if (mp3Recorder && mp3Recorder.current) {
                mp3Recorder.current.stop();
                mp3Recorder.current = null;
            }

            if (interval && interval.current) {
                clearInterval(interval.current);
                interval.current = null;
            }
        };
    }, []);

    useEffect(() => {
        getPermissionHandler();
    }, [getPermissionHandler]);

    useEffect(() => {
        if (isTryToGetPermission) {
            if (isBlocked) {
                console.log("AudioRecord - Permission Denied");
            } else {
                if (mp3Recorder && mp3Recorder.current) {
                    mp3Recorder.current.start()
                        .then(() => {
                            const v = new Date().getTime();
                            // 20261015 자동 종료 판단용 ref 설정
                            startTimeRef.current = v;
                            isRecordingRef.current = true;
                            setStartTime(v);
                            setCurTime(v);
                            setRecording(true);
                        })
                        .catch((err) => {
                            console.log("mp3Recorder.start() - err => ", err);
                            if (err instanceof Error) {
                                console.log(`Error name[${err.name}], message: ${err.message}`);
                                let errMsg = `${t("오디오_녹음_알림_메시지_7", { ns: "classTalk" })} [Error name[${err.name}], message: ${err.message}]`;
                                alert(errMsg);
                            }
                            handleSelectedClassTalkFunc({ selectedFunc: "CLOSE_VOICE_MEMO" });
                        });
                }
            }
        }
    }, [isBlocked, isTryToGetPermission]);

    useEffect(() => {
        if (isRecording) {
            interval.current = setInterval(() => {
                handleTimer();
            }, 1000);
        } else {
            if (interval && interval.current) {
                clearInterval(interval.current);
                interval.current = null;
            }
        }
    }, [isRecording]);

    const handleTimer = () => {
        const v = new Date().getTime();
        setCurTime(v);

        // 20261015 최대 녹음 시간 도달 시 자동 종료 후 전송
        if (isRecordingRef.current && v - startTimeRef.current >= MAX_RECORD_SEC * 1000) {
            handleStop();
        }
    }

    const handleStart = (e) => {
        if (!isTryToGetPermission) {
            setIsTryToGetPermission(true);
        } else {
            console.log("already recording now...");
        }
    }

    const handleStop = (e) => {
        // 20261015 isRecording state 대신 ref로 판단 (자동 종료/수동 종료 중복 실행 방지)
        // if (isRecording) {
        if (isRecordingRef.current) {
            isRecordingRef.current = false;
            if (mp3Recorder && mp3Recorder.current) {
                mp3Recorder.current.stop().getMp3()
                    .then(([buffer, blob]) => {
                        const filename = "au" + Date.now().toString() + ".mp3";
                        let reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onload = () => {
                            onHandleClassTalkFunc({ selectedFunc: "SEND_VOICE_MEMO", data: blob, fileURL: reader.result, filename });
                        };
                    })
                    .catch((err) => {
                        console.log("mp3Recorder.stop() - err => ", err);
                        if (err instanceof Error) {
                            console.log(`Error name[${err.name}], message: ${err.message}`);
                            let errMsg = `${t("오디오_녹음_알림_메시지_8", { ns: "classTalk" })} [Error name[${err.name}], message: ${err.message}]`;
                            alert(errMsg);
                        }
                        handleSelectedClassTalkFunc({ selectedFunc: "CLOSE_VOICE_MEMO" });
                    });

                setRecording(false);
                setIsTryToGetPermission(false);
            }
        } else {
            handleSelectedClassTalkFunc({ selectedFunc: "CLOSE_VOICE_MEMO" });
        }
    }

    // 20261015 남은 녹음 시간(초) 계산
    const getRemainSec = () => {
        const elapsed = isRecording ? Math.floor((curTime - startTime) / 1000) : 0;
        return Math.max(MAX_RECORD_SEC - elapsed, 0);
    }

    // 20261015 남은 녹음 시간 표시 (60초부터 1초씩 감소, mm:ss)
    const getRemainDisp = () => {
        const remain = getRemainSec();
        return String(Math.floor(remain / 60)).padStart(2, "0") + ":" + String(remain % 60).padStart(2, "0");
    }

    // 20261015 경과 시간 표시는 남은 시간 표시(getRemainDisp)로 대체 - 기존 코드 보존
    // eslint-disable-next-line no-unused-vars
    const getDisp = () => {
        const tmp = curTime - startTime;
        const t = Math.floor(tmp / 1000);
        const m = Math.floor(t / 60);

        const ss = t % 60;
        const mm = m % 60;
        const hh = Math.floor(mm / 60);

        const str_s = "0" + parseInt(ss).toString();
        const str_m = "0" + parseInt(mm).toString();
        const str_h = "0" + parseInt(hh).toString();

        const str_time = str_h.substr(str_h.length - 2, 2) + ":" + str_m.substr(str_m.length - 2, 2) + ":" + str_s.substr(str_s.length - 2, 2);
        //console.log(str_time);

        return str_time;
    }

    return (
        <div className="title-area sub hiclasstv-blue">
            {
                isRecording &&
                <div className="d-flex justify-content-start align-items-center mr-1">
                    <div className="spinner-border spinner-border-sm red-text" role="status">
                        <span className="sr-only">{t("로드_중", { ns: "classTalk" })}</span>
                    </div>
                    <span className="white-text small ml-1" >&nbsp;{t("녹음_중", { ns: "classTalk" })}</span>
                </div>
            }
            <div className="d-flex justify-content-center align-itmes-center px-1">
                <button className="d-flex rounded p-1" title={t("녹음_시작", { ns: "classTalk" })} onClick={() => handleStart()}>
                    <FaRegDotCircle className="d-flex font-md red-text " />
                </button>
                <button className="d-flex rounded p-1" title={t("녹음_종료", { ns: "classTalk" })} onClick={() => handleStop()}>
                    <FaRegStopCircle className="d-flex font-md white-text" />
                </button>
                <div className="d-flex align-items-center">
                    {/* 20261015 경과 시간 대신 남은 녹음 시간 표시, 10초 이하 빨간색 */}
                    {/* <span className="hiclass-text hiclasstv-yellow-text px-1">
                        {getDisp()}
                    </span> */}
                    <span className={"hiclass-text px-1 " + (isRecording && getRemainSec() <= WARN_REMAIN_SEC ? "red-text" : "hiclasstv-yellow-text")}>
                        {getRemainDisp()}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default AudioRecord;